import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('featured-payment-methods', {
  onLoad() {
    this.sliderId = '#featured-payment-methods__slider--' + this.id;
    const thisSlider = document.querySelector('#featured-payment-methods__slider--' + this.id);

    new Flickity(thisSlider, {
      // options
      freeScroll: false,
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true,
      setGallerySize: true,
      groupCells: true,
      cellAlign: 'left',
      watchCSS: true,
      wrapAround: false,
    });
  },
});
